import moment from 'moment';
import React, { useMemo } from 'react';
import { Linking, Text, TouchableOpacity, View } from 'react-native';
import { IconButton as RNIconButton } from 'react-native-paper';
import { createStyle } from '../style';
import { CHAIN_IDS, JPYCTransferProps, NETWORKS } from '../type';

type Props = {
  txHash: string;
  amount: number;
  chainId: CHAIN_IDS;
  onBack: () => void;
  jpycElementProps: JPYCTransferProps;
};
export const SuccessForm: React.FC<Props> = (props) => {
  const { amount, chainId, txHash, jpycElementProps, onBack } = props;
  const styles = createStyle(jpycElementProps);

  const explorerTxUrl = useMemo(() => {
    if (!txHash) return '';
    const selectedNetworkMeta = NETWORKS[chainId];
    const base = selectedNetworkMeta.blockExplorerUrls[0];
    return `${base}/tx/${txHash}`;
  }, [txHash]);
  return (
    <View style={styles.container}>
      <View style={styles.iconWrapper}>
        <View style={styles.iconCircle}>
          <RNIconButton icon="check" onPress={() => {}} color="#ffffff" />
        </View>
      </View>

      <View style={styles.headerBlock}>
        <Text style={styles.title}>支払い完了</Text>
        <Text style={styles.subtitle}>
          支払い日時：{moment().format('YYYY/MM/DD HH:mm')}
        </Text>
      </View>

      <View style={styles.amountRow}>
        <Text style={styles.amountValue}>
          {Number.isFinite(amount) ? amount : 0}
        </Text>
        <Text style={styles.amountUnit}>JPYC</Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.label}>トランザクション</Text>
        <View
          style={[
            styles.addressBox,
            { flexDirection: 'row', alignItems: 'center' },
          ]}
        >
          <Text
            style={styles.addressText}
            numberOfLines={1}
            ellipsizeMode="middle"
          >
            {txHash || '—'}
          </Text>
          <RNIconButton
            icon="open-in-new"
            color="#0175FF"
            size={14}
            onPress={() => {
              setTimeout(() => {
                Linking.openURL(explorerTxUrl);
              }, 150);
            }}
          />
        </View>
      </View>

      <TouchableOpacity
        style={styles.button}
        onPress={onBack}
        activeOpacity={0.85}
      >
        <Text style={styles.buttonText}>利用中のサービスに戻る</Text>
      </TouchableOpacity>
    </View>
  );
};
